<template>
	<div v-if="true || channel && channel.isLoaded">
		<div class="d21-language-select">
			<d21-select :list="this.languages"></d21-select>
		</div>
		<Cancellation :Channel="channel" />
	</div>
</template>

<script>
	import Cancellation from "./components/cancellation.vue";
	import appStart from "@/mixins/appStart";

	export default {
		mixins: [appStart],
		name: "d21-app-cancellation",
		components: {
			Cancellation
		},
		data() {
			return {
				routes: {
					query: null,
					checkout: "query",
					confirmation: "checkout",
					registration: null
				},
				languages: ['de-DE', 'en-US']
			};
		},
	};
</script>